import { createFileRoute, Outlet } from "@tanstack/react-router";
import { ProductSubNav } from "@/components/portal/ProductSubNav";
import { kbFileSubNav } from "@/lib/navigationItems";

export const Route = createFileRoute("/portal/knowledgebase-file")({
  component: KBFileLayout,
});

function KBFileLayout() {
  return (
    <div className="space-y-4">
      <ProductSubNav items={kbFileSubNav} />
      <Outlet />
    </div>
  );
}
